// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"style-module--sidebar--2MnPK","active":"style-module--active--rGwV_"};